import { render, staticRenderFns } from "./ClicksTooltip.vue?vue&type=template&id=2a29bfd5&"
import script from "./ClicksTooltip.vue?vue&type=script&lang=js&"
export * from "./ClicksTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports